import ErrorFallback from 'common/errorFallback/ErrorFallback';

const ErrorRoute = () => {
   return <ErrorFallback />;
};

export default ErrorRoute;
